import axios from "axios";

export function getPartners(params) {
  return axios.get("/partner/admin/api/v1/partners", { params });
}

export function getPartner(uuid) {
  return axios.get(`/partner/admin/api/v1/partners/${uuid}`);
}

export function createPartner(data) {
  return axios.post("/partner/admin/api/v1/partners", data);
}

export function updatePartner(uuid, data) {
  return axios.put(`/partner/admin/api/v1/partners/${uuid}`, data);
}

export function updatePartnerStatus(uuid, data) {
  return axios.put(`/partner/admin/api/v1/partners/${uuid}/status`, data);
}

export function getPartnerCompanies(uuid, params) {
  return axios.get(`/partner/admin/api/v1/partners/${uuid}/companies`, { params });
}

export function assignCompany(uuid, data) {
  return axios.post(`/partner/admin/api/v1/partners/${uuid}/companies`, data);
}

export function unassignCompany(uuid, assignmentId) {
  return axios.delete(`/partner/admin/api/v1/partners/${uuid}/companies/${assignmentId}`);
}

export function getPartnerActionLogs(uuid, params) {
  return axios.get(`/partner/admin/api/v1/partners/${uuid}/action-logs`, { params });
}

export function reassignCompanies(uuid, data) {
  return axios.post(`/partner/admin/api/v1/partners/${uuid}/companies/reassign`, data);
}
